import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/modules/shared.module";
import { BancosComponent } from "../views/bancos/bancos/bancos.component";
import { BtnNuevoBancoComponent } from "../views/bancos/btn-nuevo-banco/btn-nuevo-banco.component";
import { DialogBancoComponent } from "../views/bancos/dialog-banco/dialog-banco.component";
import { BuscarBancoComponent } from "../views/busquedas/buscar-banco/buscar-banco.component";
import { ParametrizacionTemplatesBancoComponent } from "../views/templates-banco/parametrizacion-templates-banco/parametrizacion-templates-banco.component";

@NgModule({
    imports:[
        CommonModule,
        SharedModule
    ],
    declarations:[
        BuscarBancoComponent,
        BancosComponent,
        DialogBancoComponent,
        BtnNuevoBancoComponent,
        ParametrizacionTemplatesBancoComponent,],
    exports:[
        BuscarBancoComponent,
        BancosComponent,
        DialogBancoComponent,
        BtnNuevoBancoComponent,
        ParametrizacionTemplatesBancoComponent,]
})

export class BancosModule{}
